import styled from 'styled-components';
import { Props } from './types';

export default styled.div.attrs({ role: 'region' })<Props>`
  display: flex;
  flex-direction: column;
  width: ${({ $width }) => $width};
`;
